import { DataBean } from "../DataBean";

export class RenderHiringDocumentStage extends DataBean {



    public async renderHiringDocumentStage(idstage: any, statedoc: any): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_renderHiringDocumentStage_Number_Number", [idstage, statedoc]);
    }

}
